import React, { useState, useCallback, useEffect } from "react";
import { get } from "../../../services/recebimentos";
import serviceCatalogos from "../../../services/catalogos";
import { downloadFile } from "../../../utils/file";
import { sumValuesArray } from "../../../utils/utils";
import { formatCurrency } from "../../../utils/Money";
const uniq = (a) => [...new Set(a)];

const RelatoriosModal = ({ campanha }) => {
  const [recebimentos, setRecebimentos] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadData = useCallback(async () => {
    setLoading(true);
    const _catalogos = serviceCatalogos.get(`?catalogo=NULL&sort=apelido&active=true`);
    const _recebimentosCampanha = get(`by-campanha/${campanha._id}`);
    const [catalogos, recebimentosCampanha] = await Promise.all([_catalogos, _recebimentosCampanha]);
    const catalogosRec = uniq(
      [...recebimentosCampanha]
        .map((e) => e.catalogoCodigo)
    );

    const catRows = catalogos.rows.filter((e) => catalogosRec.includes(e.codigo));

    setLoading(false);
		
		const recebimentosOrg = [];
    for (let rec of recebimentosCampanha) {
      const existIndex = recebimentosOrg.findIndex(
        (r) => r.usuario._id === rec.usuario._id
      );
			const catalogo = catRows.find((e) => e.codigo === rec.catalogoCodigo);
			// console.log(catalogo,rec.catalogoCodigo,'<< catalogo');
      if (existIndex !== -1) {
        recebimentosOrg[existIndex].valores.push(rec.valor);
				recebimentosOrg[existIndex].volumes.push(rec.semVolume ? 0 : 1);
				recebimentosOrg[existIndex].catalogos.push(catalogo?.apelido ?? rec.catalogoCodigo);
      } else {
        recebimentosOrg.push({
          usuario: rec.usuario,
          valores: [rec.valor],
          frete: rec.usuario.taxaManuseio ?? 0,
					catalogos: [catalogo?.apelido ?? rec.catalogoCodigo],
					volumes: [rec.semVolume ? 0 : 1]
        });
      }
    }

    setRecebimentos(recebimentosOrg);
  }, [campanha]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  const extractCSV = (tipo) => {
    if (tipo === "r") {
      extractRecebimentos();
    } else if(tipo === "v") {
			extractVolumes();
		}
  };

  const extractRecebimentos = () => {
    const headers = ["Nome;Frete;Total Lançamentos;Total Geral;Vencimento"];

    const _rec = [...recebimentos].map((e)=>{
      const obj = e;
      e.usuario.nome = e.usuario.nome.toUpperCase();
      return obj;
    });
    _rec.sort((a,b)=>a.usuario.nome > b.usuario.nome ? 1 : -1)
    // // Convert rows data to a csv
    let rowsCSV = _rec.reduce((acc, row) => {
      let { usuario, valores, frete } = row;
      const totalLancamento = parseFloat(sumValuesArray(valores).toFixed(2));
      const totalGeral = frete + totalLancamento;

      acc.push([usuario.nome,formatCurrency(frete), formatCurrency(totalLancamento),formatCurrency(totalGeral), usuario.diasPagamento.join(", ")].join(";"));
      return acc;
    }, []);

    downloadFile({
      data: [...headers, ...rowsCSV].join("\n"),
      fileName: "relatorioRecebimentos.csv",
      fileType: "text/csv",
    });
  };

	const extractVolumes = () => {
    const headers = ["Nome;Catálogos;Volumes"];
    const _rec = [...recebimentos].map((e)=>{
      const obj = e;
      e.usuario.nome = e.usuario.nome.toUpperCase();
      return obj;
    });
    _rec.sort((a,b)=>a.usuario.nome > b.usuario.nome ? 1 : -1)
    // // Convert rows data to a csv
    let rowsCSV = _rec.reduce((acc, row) => {
      let { usuario, catalogos, volumes } = row;
      catalogos = catalogos.map(e=>e.toUpperCase()).sort((a,b)=>a>b?1:-1);

      acc.push([usuario.nome.toUpperCase(), uniq(catalogos).join(', '), sumValuesArray(volumes)].join(";"));
      return acc;
    }, []);

    downloadFile({
      data: [...headers, ...rowsCSV].join("\n"),
      fileName: "relatorioVolumes.csv",
      fileType: "text/csv",
    });
  };

  return (
    <div style={{ width: "700px", padding: 10 }} className="formModule">
      {loading && <>Carregando...</>}
      {!loading && (
        <>
          <div
            className="acoes"
            style={{
              justifyContent: "flex-start",
            }}
          >
            <button onClick={() => extractCSV("r")} className="tornarRev" type="button">
              Recebimentos
            </button>

            <button onClick={() => extractCSV("v")} className="tornarRev" type="button">
              Volumes
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default RelatoriosModal;
